import { createContext, useContext, useState, useEffect } from "react";
import { getUserData, storeUserData } from "../../services/security";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(getUserData() || null);

  useEffect(() => {
    console.log("👤 User Context Updated:", user);
    if (user) {
      storeUserData(user); // Save user to localStorage when it changes
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
